// AmpBooks static data — BID_TEMPLATES, MAT_CATALOG, LABOR data
// This file is plain JS (no JSX) so it compiles fast

const BID_TEMPLATES={
  "200A Panel Upgrade":{
    description:"Upgrade existing electrical panel to 200A service. Includes new panel, breakers, permit, and inspection.",
    permitFee:150,
    laborHours:{master:8,journeyman:0,apprentice:0},
    materials:[
      {desc:"200A Main Panel Indoor",qty:1,unit:"ea",cost:255},
      {desc:"CHF115 1P 15A Breaker",qty:10,unit:"ea",cost:6},
      {desc:"CHF120 1P 20A Breaker",qty:10,unit:"ea",cost:8},
      {desc:"CHF230 2P 30A Breaker",qty:2,unit:"ea",cost:12},
      {desc:"CHF250 2P 50A Breaker",qty:1,unit:"ea",cost:18},
      {desc:"CHF260 2P 60A Breaker",qty:1,unit:"ea",cost:22},
      {desc:"2/0 Copper Service Wire",qty:10,unit:"ft",cost:4.25},
      {desc:"Ground Rod Kit",qty:1,unit:"ea",cost:35},
      {desc:"Wire Nuts (bag)",qty:1,unit:"ea",cost:8},
      {desc:"Misc Hardware / Supplies (lot)",qty:1,unit:"lot",cost:50},
    ]
  },
  "Service Call / Troubleshoot":{
    description:"Diagnose and repair electrical issue. Includes travel, diagnostics, and up to 2 hours labor.",
    permitFee:0,
    laborHours:{master:2,journeyman:0,apprentice:0},
    materials:[
      {desc:"Misc Parts (lot)",qty:1,unit:"lot",cost:25},
    ]
  },
  "GFCI Outlet Install":{
    description:"Install GFCI protected outlets. Includes all materials and labor.",
    permitFee:0,
    laborHours:{master:2,journeyman:0,apprentice:0},
    materials:[
      {desc:"GFCI Outlet 20A - Decora",qty:4,unit:"ea",cost:18},
      {desc:"Single Gang Plate - Decora",qty:4,unit:"ea",cost:1.25},
      {desc:"Single Gang Old Work Box",qty:4,unit:"ea",cost:1.50},
      {desc:"Wire Nuts (bag)",qty:1,unit:"ea",cost:8},
      {desc:"Misc Hardware / Supplies (lot)",qty:1,unit:"lot",cost:15},
    ]
  },
  "Whole House Rewire":{
    description:"Complete rewire of existing 3/2 home. Includes all new wiring, devices, panel, permit and inspection.",
    permitFee:350,
    laborHours:{master:40,journeyman:0,apprentice:0},
    materials:[
      {desc:"14/2 NM Wire",qty:1500,unit:"ft",cost:0.44},
      {desc:"12/2 NM Wire",qty:600,unit:"ft",cost:0.62},
      {desc:"10/2 NM Wire",qty:50,unit:"ft",cost:1.14},
      {desc:"10/3 NM Wire",qty:50,unit:"ft",cost:1.41},
      {desc:"14/3 NM Wire",qty:250,unit:"ft",cost:0.59},
      {desc:"200A Main Panel Indoor",qty:1,unit:"ea",cost:255},
      {desc:"CHF115 1P 15A Breaker",qty:10,unit:"ea",cost:6},
      {desc:"CHF120 1P 20A Breaker",qty:8,unit:"ea",cost:8},
      {desc:"CHF230 2P 30A Breaker",qty:2,unit:"ea",cost:12},
      {desc:"CHF250 2P 50A Breaker",qty:1,unit:"ea",cost:18},
      {desc:"CHF260 2P 60A Breaker",qty:1,unit:"ea",cost:22},
      {desc:"CHFP120DF 20A Dual Function PON",qty:10,unit:"ea",cost:60},
      {desc:"15A Outlet - Standard",qty:20,unit:"ea",cost:1.50},
      {desc:"Single Pole Switch - Standard",qty:10,unit:"ea",cost:2.00},
      {desc:"GFCI Outlet 20A - Decora",qty:8,unit:"ea",cost:18},
      {desc:"Single Gang Plate - Standard",qty:30,unit:"ea",cost:0.75},
      {desc:"Single Gang Old Work Box",qty:30,unit:"ea",cost:1.50},
      {desc:"Ceiling Box Old Work",qty:8,unit:"ea",cost:3.50},
      {desc:"Smoke/CO Combo Detector Hardwired w/ Battery Backup",qty:5,unit:"ea",cost:42},
      {desc:"Cable Staples 1/2\" (box)",qty:3,unit:"ea",cost:12},
      {desc:"Wire Nuts (bag)",qty:4,unit:"ea",cost:8},
      {desc:"Misc Hardware / Supplies (lot)",qty:1,unit:"lot",cost:150},
    ]
  },
  "EV Charger Install":{
    description:"Install Level 2 EV charging station. Includes dedicated 50A circuit, wiring, outlet/hardwire, and permit.",
    permitFee:100,
    laborHours:{master:4,journeyman:0,apprentice:0},
    materials:[
      {desc:"CHF250 2P 50A Breaker",qty:1,unit:"ea",cost:18},
      {desc:"6/3 NM Wire",qty:50,unit:"ft",cost:3.98},
      {desc:"Range Outlet 14-50R",qty:1,unit:"ea",cost:22},
      {desc:"EMT 1/2\"",qty:20,unit:"ft",cost:0.45},
      {desc:"EMT Connector 1/2\"",qty:4,unit:"ea",cost:0.65},
      {desc:"Weatherproof Box",qty:1,unit:"ea",cost:6},
      {desc:"Misc Hardware / Supplies (lot)",qty:1,unit:"lot",cost:25},
    ]
  },
  "Ceiling Fan / Light Fixture":{
    description:"Install ceiling fan or light fixture. Includes wiring, mounting hardware, and switch if needed.",
    permitFee:0,
    laborHours:{master:1.5,journeyman:0,apprentice:0},
    materials:[
      {desc:"Ceiling Fan Brace Box",qty:1,unit:"ea",cost:14},
      {desc:"14/2 NM Wire",qty:25,unit:"ft",cost:0.44},
      {desc:"Single Pole Switch - Decora",qty:1,unit:"ea",cost:3.00},
      {desc:"Single Gang Old Work Box",qty:1,unit:"ea",cost:1.50},
      {desc:"Single Gang Plate - Decora",qty:1,unit:"ea",cost:1.25},
      {desc:"Wire Nuts (bag)",qty:1,unit:"ea",cost:8},
    ]
  },
  "Generator Install":{
    description:"Install standby generator with service-rated automatic transfer switch (ATS) at meter. Includes all electrical connections, feeder run, and permit.",
    permitFee:200,
    laborHours:{master:16,journeyman:0,apprentice:0},
    materials:[
      {desc:"3/0 Copper Service Wire",unit:"ft",qty:50,cost:6.50},
      {desc:"PVC Schedule 40 2\"",qty:50,unit:"ft",cost:1.35},
      {desc:"PVC Connector 3/4\"",qty:4,unit:"ea",cost:0.55},
      {desc:"PVC Coupling 3/4\"",qty:4,unit:"ea",cost:0.45},
      {desc:"LB Conduit Body 1\"",qty:1,unit:"ea",cost:9.00},
      {desc:"Weather head / Service Entrance Cap",qty:1,unit:"ea",cost:25},
      {desc:"Ground Rod Kit",qty:1,unit:"ea",cost:35},
      {desc:"Wire Nuts (bag)",qty:2,unit:"ea",cost:8},
      {desc:"Misc Hardware / Supplies (lot)",qty:1,unit:"lot",cost:75},
    ]
  },
  "Blank / Custom":{
    description:"",
    permitFee:0,
    laborHours:{master:0,journeyman:0,apprentice:0},
    materials:[]
  },
};

// Labor hour multipliers by job type and wire type
const LABOR_FACTORS={
  jobType:{
    "New Construction":1.0,
    "Remodel":1.4,
    "Service Work":1.2,
  },
  wireType:{
    "Romex (NM)":1.0,
    "MC Cable":1.25,
    "EMT Conduit":1.6,
    "PVC Conduit":1.5,
    "Mixed":1.2,
  },
  accessType:{
    "Open/Easy Access":1.0,
    "Attic Access":1.15,
    "Crawl Space":1.2,
    "Concrete Block":1.35,
    "Two Story":1.2,
    "No Access (Full Fish)":1.5,
  }
};

// ── Materials Catalog ─────────────────────────────────────────────────────
const MAT_CATALOG={
  "Wire":[
    {desc:"14/2 NM Wire",unit:"ft",cost:0.44},
    {desc:"12/2 NM Wire",unit:"ft",cost:0.62},
    {desc:"10/2 NM Wire",unit:"ft",cost:1.14},
    {desc:"10/3 NM Wire",unit:"ft",cost:1.41},
    {desc:"8/2 NM Wire",unit:"ft",cost:1.93},
    {desc:"8/3 NM Wire",unit:"ft",cost:2.72},
    {desc:"6/2 NM Wire",unit:"ft",cost:2.73},
    {desc:"6/3 NM Wire",unit:"ft",cost:3.98},
    {desc:"14/3 NM Wire",unit:"ft",cost:0.59},
    {desc:"12/3 NM Wire",unit:"ft",cost:0.89},
    {desc:"2/0 Copper Service Wire",unit:"ft",cost:4.25},
    {desc:"3/0 Copper Service Wire",unit:"ft",cost:5.36},
    {desc:"6/6/8 SER Copper",unit:"ft",cost:9.00},
    {desc:"THWN 12 AWG",unit:"ft",cost:0.48},
    {desc:"THWN 10 AWG",unit:"ft",cost:0.73},
    {desc:"THWN 6 AWG",unit:"ft",cost:0.42},
    {desc:"THWN 8 AWG",unit:"ft",cost:0.27},
    {desc:"THWN 4 AWG",unit:"ft",cost:0.64},
    {desc:"THWN 3 AWG",unit:"ft",cost:2.02},
    {desc:"THWN 2 AWG",unit:"ft",cost:2.53},
    {desc:"THWN 1 AWG",unit:"ft",cost:2.82},
    {desc:"THWN 1/0 AWG",unit:"ft",cost:3.45},
    {desc:"THWN 2/0 AWG",unit:"ft",cost:4.25},
    {desc:"THWN 3/0 AWG",unit:"ft",cost:5.36},
  ],
  "Breakers (Eaton CHF)":[
    {desc:"CHF115 1P 15A Breaker",unit:"ea",cost:7.50},
    {desc:"CHF120 1P 20A Breaker",unit:"ea",cost:7.50},
    {desc:"CHF130 1P 30A Breaker",unit:"ea",cost:7.50},
    {desc:"CHF215 2P 15A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF220 2P 20A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF225 2P 25A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF230 2P 30A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF240 2P 40A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF245 2P 45A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF250 2P 50A Breaker",unit:"ea",cost:16.50},
    {desc:"CHF260 2P 60A Breaker",unit:"ea",cost:18.00},
    {desc:"CH270 2P 70A Breaker",unit:"ea",cost:55.00},
    {desc:"CH280 2P 80A Breaker",unit:"ea",cost:55.00},
    {desc:"CH290 2P 90A Breaker",unit:"ea",cost:55.00},
    {desc:"CH2100 2P 100A Breaker",unit:"ea",cost:62.00},
    {desc:"CH2125 2P 125A Breaker",unit:"ea",cost:135.00},
    {desc:"CHFP115AF 15A AFCI PON",unit:"ea",cost:58.00},
    {desc:"CHFP120AF 20A AFCI PON",unit:"ea",cost:58.00},
    {desc:"CHFP115GF 1P 15A GFCI PON",unit:"ea",cost:60.00},
    {desc:"CHFP120GF 1P 20A GFCI PON",unit:"ea",cost:60.00},
    {desc:"CHFP115DF 15A Dual Function PON",unit:"ea",cost:89.00},
    {desc:"CHFP120DF 20A Dual Function PON",unit:"ea",cost:95.00},
    {desc:"CHFN220GF 2P 20A GFI",unit:"ea",cost:190.00},
    {desc:"CHFN230GF 2P 30A GFI",unit:"ea",cost:190.00},
    {desc:"CHFN250GF 2P 50A GFI",unit:"ea",cost:190.00},
    {desc:"CHN240GF 2P 40A GFI",unit:"ea",cost:190.00},
    {desc:"CHN260GF 2P 60A GFI",unit:"ea",cost:190.00},
    {desc:"CHPSURGE10 20KA SPD Surge Protector",unit:"ea",cost:130.00},
  ],
  "Panels & Disconnects":[
    {desc:"200A Convertible N3R Panel",unit:"ea",cost:250},
    {desc:"200A MB Loadcenter 42-space",unit:"ea",cost:255},
    {desc:"225A MLO Convertible Panel",unit:"ea",cost:155},
    {desc:"225A Convertible Outdoor 42-space",unit:"ea",cost:335},
    {desc:"200A MB PON Loadcenter 32-space",unit:"ea",cost:235},
    {desc:"225A Loadcenter 32-space",unit:"ea",cost:315},
    {desc:"200A Main Panel Indoor",unit:"ea",cost:255},
    {desc:"200A Main Panel Outdoor",unit:"ea",cost:335},
    {desc:"125A Loadcenter 12-space",unit:"ea",cost:125},
    {desc:"125A Loadcenter 16-space",unit:"ea",cost:98},
    {desc:"125A Loadcenter 24-space",unit:"ea",cost:185},
    {desc:"400A Main Panel",unit:"ea",cost:650},
    {desc:"200A Service Rated ATS",unit:"ea",cost:850},
    {desc:"400A Service Rated ATS",unit:"ea",cost:1450},
    {desc:"200A Manual Transfer Switch",unit:"ea",cost:350},
    {desc:"400A Manual Transfer Switch",unit:"ea",cost:650},
    {desc:"Interlock Kit",unit:"ea",cost:45},
    {desc:"Weather head / Service Entrance Cap",unit:"ea",cost:25},
    {desc:"Ground Rod Kit",unit:"ea",cost:35},
    {desc:"60A Disconnect Non-Fusible",unit:"ea",cost:45},
    {desc:"60A Disconnect Fusible",unit:"ea",cost:55},
    {desc:"100A Disconnect Non-Fusible",unit:"ea",cost:75},
    {desc:"100A Disconnect Fusible",unit:"ea",cost:90},
    {desc:"200A Disconnect Non-Fusible",unit:"ea",cost:140},
    {desc:"200A Disconnect Fusible",unit:"ea",cost:165},
    {desc:"AC Disconnect 30A",unit:"ea",cost:35},
    {desc:"AC Disconnect 60A",unit:"ea",cost:55},
    {desc:"Safety Switch 30A",unit:"ea",cost:45},
    {desc:"Safety Switch 60A",unit:"ea",cost:65},
    {desc:"Safety Switch 100A",unit:"ea",cost:95},
    {desc:"30A Weatherproof Disconnect Non-Fusible",unit:"ea",cost:55},
    {desc:"30A Weatherproof Disconnect Fusible",unit:"ea",cost:65},
    {desc:"60A Weatherproof Disconnect Non-Fusible",unit:"ea",cost:75},
    {desc:"60A Weatherproof Disconnect Fusible",unit:"ea",cost:90},
    {desc:"100A Weatherproof Disconnect Non-Fusible",unit:"ea",cost:110},
    {desc:"100A Weatherproof Disconnect Fusible",unit:"ea",cost:130},
    {desc:"200A Weatherproof Disconnect Non-Fusible",unit:"ea",cost:175},
    {desc:"200A Weatherproof Disconnect Fusible",unit:"ea",cost:200},
  ],
  "Boxes":[
    {desc:"Single Gang Old Work Box",unit:"ea",cost:2.52},
    {desc:"Single Gang New Work Box",unit:"ea",cost:1.39},
    {desc:"Single Gang Bracket",unit:"ea",cost:1.10},
    {desc:"Single Gang Nail-On Box",unit:"ea",cost:1.45},
    {desc:"Double Gang Old Work Box",unit:"ea",cost:5.20},
    {desc:"Double Gang New Work Box",unit:"ea",cost:5.30},
    {desc:"Triple Gang Old Work Box",unit:"ea",cost:15.65},
    {desc:"4-Gang Old Work Box",unit:"ea",cost:7.01},
    {desc:"Ceiling Box Old Work",unit:"ea",cost:5.06},
    {desc:"Ceiling Box New Work",unit:"ea",cost:2.92},
    {desc:"Ceiling Fan Brace Box",unit:"ea",cost:11.96},
    {desc:"4\" Fan Pancake Box",unit:"ea",cost:9.99},
    {desc:"4\" Square 1-1/4D Box",unit:"ea",cost:2.35},
    {desc:"4\" Square 1-1/2D Box",unit:"ea",cost:1.61},
    {desc:"4\" Square 2-1/8D Box",unit:"ea",cost:2.36},
    {desc:"Weatherproof Box",unit:"ea",cost:6.00},
    {desc:"Junction Box",unit:"ea",cost:4.00},
  ],
  "Outlets":[
    {desc:"15A Outlet - Standard",unit:"ea",cost:1.50},
    {desc:"15A Outlet - Decora",unit:"ea",cost:2.50},
    {desc:"20A Outlet - Standard",unit:"ea",cost:3.00},
    {desc:"20A Outlet - Decora",unit:"ea",cost:4.00},
    {desc:"GFCI Outlet 15A - Decora",unit:"ea",cost:14},
    {desc:"GFCI Outlet 20A - Decora",unit:"ea",cost:18},
    {desc:"Weatherproof Outlet 15A In-Use Cover",unit:"ea",cost:12},
    {desc:"Weatherproof Outlet 20A In-Use Cover",unit:"ea",cost:14},
    {desc:"GFCI Weatherproof Outlet 15A Decora",unit:"ea",cost:18},
    {desc:"GFCI Weatherproof Outlet 20A Decora",unit:"ea",cost:22},
    {desc:"Dryer Outlet 14-30R",unit:"ea",cost:18},
    {desc:"Range Outlet 14-50R",unit:"ea",cost:22},
    {desc:"USB Outlet",unit:"ea",cost:18},
  ],
  "Switches":[
    {desc:"Single Pole Switch - Standard",unit:"ea",cost:2.00},
    {desc:"Single Pole Switch - Decora",unit:"ea",cost:3.00},
    {desc:"3-Way Switch - Standard",unit:"ea",cost:4.00},
    {desc:"3-Way Switch - Decora",unit:"ea",cost:5.50},
    {desc:"Dimmer Switch - Standard",unit:"ea",cost:12},
    {desc:"Dimmer Switch - Decora",unit:"ea",cost:15},
  ],
  "Wall Plates":[
    {desc:"Single Gang Plate - Standard",unit:"ea",cost:0.75},
    {desc:"Single Gang Plate - Decora",unit:"ea",cost:1.25},
    {desc:"2 Gang Plate - Standard",unit:"ea",cost:1.25},
    {desc:"2 Gang Plate - Decora",unit:"ea",cost:1.75},
    {desc:"3 Gang Plate - Standard",unit:"ea",cost:1.75},
    {desc:"3 Gang Plate - Decora",unit:"ea",cost:2.25},
    {desc:"4 Gang Plate - Standard",unit:"ea",cost:2.25},
    {desc:"4 Gang Plate - Decora",unit:"ea",cost:2.75},
    {desc:"Weatherproof Cover - Single",unit:"ea",cost:4.00},
    {desc:"Weatherproof Cover - Double",unit:"ea",cost:6.00},
  ],
  "Lighting Fixtures":[
    {desc:"4\" LED Recessed Can - New Construction",unit:"ea",cost:18},
    {desc:"4\" LED Recessed Can - Remodel/Retrofit",unit:"ea",cost:22},
    {desc:"6\" LED Recessed Can - New Construction",unit:"ea",cost:22},
    {desc:"6\" LED Recessed Can - Remodel/Retrofit",unit:"ea",cost:26},
    {desc:"Surface Mount LED Ceiling Fixture",unit:"ea",cost:28},
    {desc:"Flush Mount Light Fixture",unit:"ea",cost:25},
    {desc:"Pendant Light Fixture",unit:"ea",cost:35},
    {desc:"Vanity / Bath Bar Light",unit:"ea",cost:30},
    {desc:"Exterior Wall Light Fixture",unit:"ea",cost:32},
    {desc:"Exterior Flood Light Fixture",unit:"ea",cost:28},
    {desc:"Under-Cabinet LED Strip Light",unit:"ft",cost:6},
    {desc:"Magnitude 24V LED Driver 40W",unit:"ea",cost:83.34},
    {desc:"Magnitude 24V LED Driver 60W",unit:"ea",cost:90.00},
    {desc:"Magnitude 24V LED Driver 96W",unit:"ea",cost:99.75},
    {desc:"4\" LED Wafer/Disc Light",unit:"ea",cost:25},
    {desc:"6\" LED Wafer/Disc Light",unit:"ea",cost:25},
  ],
  "Conduit":[
    {desc:"EMT 1/2\"",unit:"ft",cost:0.45},
    {desc:"EMT 3/4\"",unit:"ft",cost:0.65},
    {desc:"EMT 1\"",unit:"ft",cost:0.95},
    {desc:"EMT 1-1/4\"",unit:"ft",cost:1.40},
    {desc:"EMT 1-1/2\"",unit:"ft",cost:1.75},
    {desc:"EMT 2\"",unit:"ft",cost:2.20},
    {desc:"PVC Schedule 40 1/2\"",unit:"ft",cost:0.30},
    {desc:"PVC Schedule 40 3/4\"",unit:"ft",cost:0.45},
    {desc:"PVC Schedule 40 1\"",unit:"ft",cost:0.65},
    {desc:"PVC Schedule 40 1-1/4\"",unit:"ft",cost:0.85},
    {desc:"PVC Schedule 40 1-1/2\"",unit:"ft",cost:1.05},
    {desc:"PVC Schedule 40 2\"",unit:"ft",cost:1.35},
    {desc:"PVC Schedule 80 1/2\"",unit:"ft",cost:0.55},
    {desc:"PVC Schedule 80 3/4\"",unit:"ft",cost:0.75},
    {desc:"PVC Schedule 80 1\"",unit:"ft",cost:1.05},
    {desc:"Flexible Conduit (Greenfield) 1/2\"",unit:"ft",cost:0.55},
    {desc:"Flexible Conduit (Greenfield) 3/4\"",unit:"ft",cost:0.80},
    {desc:"Liquid-Tight Flexible 1/2\"",unit:"ft",cost:0.85},
    {desc:"Liquid-Tight Flexible 3/4\"",unit:"ft",cost:1.10},
  ],
  "Conduit Fittings":[
    {desc:"EMT Connector 1/2\"",unit:"ea",cost:0.65},
    {desc:"EMT Connector 3/4\"",unit:"ea",cost:0.95},
    {desc:"EMT Connector 1\"",unit:"ea",cost:1.50},
    {desc:"EMT Coupling 1/2\"",unit:"ea",cost:0.55},
    {desc:"EMT Coupling 3/4\"",unit:"ea",cost:0.85},
    {desc:"EMT Coupling 1\"",unit:"ea",cost:1.25},
    {desc:"PVC Connector 1/2\"",unit:"ea",cost:0.35},
    {desc:"PVC Connector 3/4\"",unit:"ea",cost:0.55},
    {desc:"PVC Coupling 1/2\"",unit:"ea",cost:0.30},
    {desc:"PVC Coupling 3/4\"",unit:"ea",cost:0.45},
    {desc:"LB Conduit Body 1/2\"",unit:"ea",cost:4.50},
    {desc:"LB Conduit Body 3/4\"",unit:"ea",cost:6.50},
    {desc:"LB Conduit Body 1\"",unit:"ea",cost:9.00},
    {desc:"Conduit Strap 1/2\"",unit:"ea",cost:0.35},
    {desc:"Conduit Strap 3/4\"",unit:"ea",cost:0.45},
    {desc:"Conduit Strap 1\"",unit:"ea",cost:0.65},
    {desc:"Conduit Hanger 1/2\"",unit:"ea",cost:0.45},
    {desc:"Conduit Hanger 3/4\"",unit:"ea",cost:0.55},
  ],
  "Smoke & CO Detectors":[
    {desc:"Smoke Detector Hardwired",unit:"ea",cost:18},
    {desc:"Smoke Detector Hardwired w/ Battery Backup",unit:"ea",cost:24},
    {desc:"Smoke/CO Combo Detector Hardwired",unit:"ea",cost:35},
    {desc:"Smoke/CO Combo Detector Hardwired w/ Battery Backup",unit:"ea",cost:42},
    {desc:"Smoke Detector Battery Only",unit:"ea",cost:12},
    {desc:"Smoke/CO Combo Battery Only",unit:"ea",cost:22},
    {desc:"CO Detector Hardwired",unit:"ea",cost:28},
    {desc:"CO Detector Battery Only",unit:"ea",cost:18},
  ],
  "Misc Hardware":[
    {desc:"Wire Nuts (bag)",unit:"ea",cost:8},
    {desc:"Cable Staples 1/2\" (box)",unit:"ea",cost:12},
    {desc:"Cable Staples 3/4\" (box)",unit:"ea",cost:14},
    {desc:"Cable Staples 1\" (box)",unit:"ea",cost:16},
    {desc:"Romex Staples (box)",unit:"ea",cost:10},
    {desc:"Wire Connectors (bag)",unit:"ea",cost:8},
    {desc:"Push-In Connectors (bag)",unit:"ea",cost:12},
    {desc:"Electrical Tape (roll)",unit:"ea",cost:3},
    {desc:"Pull String / Fish Tape",unit:"ea",cost:25},
    {desc:"Wire Loom / Split Conduit (ft)",unit:"ft",cost:0.85},
    {desc:"Weatherproof Sealant / Caulk",unit:"ea",cost:8},
    {desc:"Drywall Anchors (box)",unit:"ea",cost:6},
    {desc:"Outlet Box Extenders (bag)",unit:"ea",cost:8},
    {desc:"Misc Hardware / Supplies (lot)",unit:"lot",cost:50},
    {desc:"Misc Parts (lot)",unit:"lot",cost:50},
  ],
};

// Flat lookup for price updates from invoice scanning
const MAT_CATALOG_FLAT=Object.values(MAT_CATALOG).flat();


export { BID_TEMPLATES, MAT_CATALOG, MAT_CATALOG_FLAT };
